import React from 'react';
import { FaEdit } from 'react-icons/fa';
import HongButton from '../../comm/HongButton';
import HongInput from '../../comm/HongInput';

function BillNoteSelect({ value, onChange, options, emptyLabel = '메모 없음' }) {
    return (
        <select className='menu-note-select' value={value} onChange={onChange}>
            {options.length === 0 && <option value=''>{emptyLabel}</option>}
            {options.map((item, index) => (
                <option key={`${item.value}-${index}`} value={item.value}>
                    {item.label}
                </option>
            ))}
        </select>
    );
}

function DesktopMenuControls(props) {
    const {
        userMemo,
        onUserMemoChange,
        useyn,
        isAiVertex,
        onUse,
        onStop,
        onEnableAi,
        onDisableAi,
        onSaveMemo,
        maxPage,
        onMaxPageChange,
        onSaveMaxPage,
        callPrice,
        onCallPriceChange,
        selectedBillNote,
        onSelectedBillNoteChange,
        billNoteOptions,
        onSaveAiCharge,
        eventChargePrice,
        onEventChargeChange,
        selectedEventBillNote,
        onSelectedEventBillNoteChange,
        eventBillNoteOptions,
        onSaveEventCharge,
        chargeSmsMessage,
        onChargeSmsChange,
        isChargeSmsOverLimit,
        onApplyChargeSmsTemplate,
        onSendChargeSms
    } = props;

    return (
        <div className='member-menu-panel member-menu-panel-desktop'>
            <div className='desktop-menu-top-row'>
                <div className='desktop-menu-actions'>
                    <HongButton className='btn h-btn-green' disabled={useyn === 'Y'} onClick={onUse}>사용</HongButton>
                    <HongButton className='btn h-btn-red' disabled={useyn === 'N'} onClick={onStop}>중지</HongButton>
                    <HongButton className='btn h-btn-dark' disabled={isAiVertex === 'Y'} onClick={onEnableAi}>AI 사용</HongButton>
                    <HongButton className='btn h-btn-white' disabled={isAiVertex !== 'Y'} onClick={onDisableAi}>AI 삭제</HongButton>

                    <div className='desktop-maxpage-group'>
                        <label className='menu-field-label'>maxpg</label>
                        <HongInput
                            isNumber={true}
                            isNegative={false}
                            useComma={false}
                            className='input-maxpage'
                            onChange={onMaxPageChange}
                            value={maxPage}
                        />
                        <HongButton className='btn h-btn-dark btn-maxpage' onClick={onSaveMaxPage}>저장</HongButton>
                    </div>

                    <div className='desktop-memo-group'>
                        <HongInput
                            className='input-usermemo'
                            onChange={onUserMemoChange}
                            value={userMemo}
                        />
                        <HongButton className='btn h-btn-white btn-memo-save' onClick={onSaveMemo}>메모저장</HongButton>
                    </div>
                </div>
            </div>

            <div className='desktop-menu-charge-row'>
                <div className='desktop-charge-group'>
                    <label className='menu-field-label input-event-charge'>금액</label>
                    <HongInput
                        isNumber={true}
                        isNegative={true}
                        useComma={true}
                        className='input-callcnt'
                        onChange={onCallPriceChange}
                        value={callPrice}
                    />
                    <BillNoteSelect
                        value={selectedBillNote}
                        onChange={onSelectedBillNoteChange}
                        options={billNoteOptions}
                    />
                    <HongButton className='btn h-btn-dark btn-charge' onClick={onSaveAiCharge}>충전1</HongButton>
                </div>

                <div className='desktop-charge-group'>
                    <label className='menu-field-label'>이벤트</label>
                    <HongInput
                        isNumber={true}
                        isNegative={true}
                        useComma={true}
                        className='input-callcnt input-event-charge'
                        onChange={onEventChargeChange}
                        value={eventChargePrice}
                    />
                    <BillNoteSelect
                        value={selectedEventBillNote}
                        onChange={onSelectedEventBillNoteChange}
                        options={eventBillNoteOptions}
                    />
                    <HongButton className='btn h-btn-dark btn-charge btn-charge-secondary' onClick={onSaveEventCharge}>충전2</HongButton>
                </div>

                <div className='desktop-sms-group'>
                    <div className={`desktop-charge-sms-box ${isChargeSmsOverLimit ? 'is-over-limit' : ''}`}>
                        <input
                            type='text'
                            className='input-charge-sms'
                            value={chargeSmsMessage}
                            onChange={onChargeSmsChange}
                            placeholder='충전 문자 내용을 입력하세요'
                        />
                    </div>
                    <HongButton
                        className='btn h-btn-white btn-charge-template'
                        onClick={onApplyChargeSmsTemplate}
                        reactIcon={<FaEdit />}
                        aria-label='충전상용구'
                        title='충전상용구'
                    />
                    <HongButton className='btn h-btn-dark btn-charge-sms' onClick={onSendChargeSms}>문자전송</HongButton>
                </div>
            </div>
        </div>
    );
}

function MobileMenuControls(props) {
    const {
        userMemo,
        onUserMemoChange,
        useyn,
        isAiVertex,
        onUse,
        onStop,
        onEnableAi,
        onDisableAi,
        onSaveMemo,
        maxPage,
        onMaxPageChange,
        onSaveMaxPage,
        callPrice,
        onCallPriceChange,
        selectedBillNote,
        onSelectedBillNoteChange,
        billNoteOptions,
        onSaveAiCharge,
        eventChargePrice,
        onEventChargeChange,
        selectedEventBillNote,
        onSelectedEventBillNoteChange,
        eventBillNoteOptions,
        onSaveEventCharge,
        chargeSmsMessage,
        onChargeSmsChange,
        isChargeSmsOverLimit,
        onApplyChargeSmsTemplate,
        onSendChargeSms
    } = props;

    return (
        <div className='member-menu-panel member-menu-panel-mobile'>
            <div className='mobile-menu-memo-box'>
                <HongInput
                    className='input-usermemo'
                    onChange={onUserMemoChange}
                    value={userMemo}
                />
            </div>

            <div className='mobile-menu-action-grid'>
                <HongButton className='btn h-btn-green' disabled={useyn === 'Y'} onClick={onUse}>사용</HongButton>
                <HongButton className='btn h-btn-red' disabled={useyn === 'N'} onClick={onStop}>중지</HongButton>
                <HongButton className='btn h-btn-dark' disabled={isAiVertex === 'Y'} onClick={onEnableAi}>AI 사용</HongButton>
                <HongButton className='btn h-btn-white' disabled={isAiVertex !== 'Y'} onClick={onDisableAi}>AI 삭제</HongButton>
                <HongButton className='btn h-btn-white btn-memo-save' onClick={onSaveMemo}>메모저장</HongButton>
            </div>

            <div className='mobile-maxpage-row'>
                <label className='menu-field-label'>maxpg</label>
                <HongInput
                    isNumber={true}
                    isNegative={false}
                    useComma={false}
                    className='input-maxpage'
                    onChange={onMaxPageChange}
                    value={maxPage}
                />
                <HongButton className='btn h-btn-dark btn-maxpage' onClick={onSaveMaxPage}>저장</HongButton>
            </div>

            <div className='mobile-charge-row'>
                <label className='menu-field-label'>금액</label>
                <HongInput
                    isNumber={true}
                    isNegative={true}
                    useComma={true}
                    className='input-callcnt'
                    onChange={onCallPriceChange}
                    value={callPrice}
                />
                <div className='mobile-charge-actions'>
                    <BillNoteSelect
                        value={selectedBillNote}
                        onChange={onSelectedBillNoteChange}
                        options={billNoteOptions}
                    />
                    <HongButton className='btn h-btn-dark btn-charge' onClick={onSaveAiCharge}>충전1</HongButton>
                </div>
            </div>

            <div className='mobile-charge-row'>
                <label className='menu-field-label'>이벤트</label>
                <HongInput
                    isNumber={true}
                    isNegative={true}
                    useComma={true}
                    className='input-callcnt input-event-charge'
                    onChange={onEventChargeChange}
                    value={eventChargePrice}
                />
                <div className='mobile-charge-actions'>
                    <BillNoteSelect
                        value={selectedEventBillNote}
                        onChange={onSelectedEventBillNoteChange}
                        options={eventBillNoteOptions}
                    />
                    <HongButton className='btn h-btn-dark btn-charge btn-charge-secondary' onClick={onSaveEventCharge}>충전2</HongButton>
                </div>
            </div>

            <div className='mobile-sms-row'>
                <div className={`mobile-charge-sms-box ${isChargeSmsOverLimit ? 'is-over-limit' : ''}`}>
                    <input
                        type='text'
                        className='input-charge-sms'
                        value={chargeSmsMessage}
                        onChange={onChargeSmsChange}
                        placeholder='충전 문자 내용을 입력하세요'
                    />
                </div>
                <HongButton
                    className='btn h-btn-white btn-charge-template'
                    onClick={onApplyChargeSmsTemplate}
                    reactIcon={<FaEdit />}
                    aria-label='충전상용구'
                    title='충전상용구'
                />
                <HongButton className='btn h-btn-dark btn-charge-sms' onClick={onSendChargeSms}>문자전송</HongButton>
            </div>
        </div>
    );
}

export default function OpenSatusUsersMenu(props) {
    return (
        <div className='member-menu-panels'>
            <DesktopMenuControls {...props} />
            <MobileMenuControls {...props} />
        </div>
    );
}